import { Schema } from "@comparaonline/products-schema";
import { captureException } from "@sentry/browser";

import {
  MutationArgs,
  MutationFunction
} from "../../../../../../queries/reviews/components/CreateProductReviewMutation";

type FormValues = Pick<MutationArgs, "comment" | "userName" | "value" | "userEmail">;

export const submitReview = (
  submitFn: MutationFunction,
  product: Schema.ProductListProduct,
  businessUnitCode: string,
  onComplete: () => void
) => (formValues: FormValues): MutationArgs =>
  submitFn({
    variables: {
      ...formValues,
      businessUnit: businessUnitCode,
      productId: parseInt(product.id, 10)
    }
  })
    .then(onComplete)
    .catch(captureException);
